// Qué modelos de una tabla van desplegados. Llegar con un SKU elegido despliega su modelo.
import { useState } from 'react';
import { entryKeyOfSku, type CatalogEntry } from '../lib/modelGroups';

export function useExpandedModels(entries: readonly CatalogEntry[], selectedSku: string | null) {
    const [expanded, setExpanded] = useState<ReadonlySet<string>>(() => new Set());
    const [revealedSku, setRevealedSku] = useState<string | null>(null);

    // Un SKU elegido desde fuera (`?sku=`, «Similares») abre su modelo una sola vez.
    if (selectedSku !== null && selectedSku !== revealedSku) {
        const key = entryKeyOfSku(entries, selectedSku);
        if (key !== null) {
            setRevealedSku(selectedSku);
            if (key.startsWith('model:') && !expanded.has(key)) {
                setExpanded(new Set([...expanded, key]));
            }
        }
    }

    const toggle = (key: string): void => {
        setExpanded((current) => {
            const next = new Set(current);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };

    return { expanded, toggle };
}
